//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: Object,
    nameList: Object
  },
  mounted () {
    setTimeout(() => {
      let dom = document.getElementsByClassName('cate-wrap')[0]
      let img = dom.getElementsByTagName('img')
      for (let i = 0; i < img.length; i++) {
        let item = img[i]
        let src = item.getAttribute('src')
        if (src && src.indexOf('/upload') === 0) {
          item.setAttribute('src', 'http://www.quanruntong.com' + src)
        }
      }
    }, 100)
  }
}



// WEBPACK FOOTER //
// ./src/pages/cate/components/cateDetail.vue